/**
 * 리스트에서 상세, 수정 클릭 시 해당 정보 전달
 */

import { create } from "zustand";

type DetailParams = {
  no: string;
  rgSeq: number;
  btnNm: string;
  param?: any;
};

interface SetDetailInfState {
  listRowInf: DetailParams;
  setListRowParams: (params: DetailParams) => void;
  resetListRowParams: () => void;
}

const useListRowInfStroe = create<SetDetailInfState>((set) => ({
  listRowInf: {
    no: "",
    rgSeq: 0,
    btnNm: "",
    param: null,
  },

  setListRowParams: (params) => {
    set({
      listRowInf: {
        ...params,
      },
    });
  },

  resetListRowParams: () => {
    set({
      listRowInf: {
        no: "",
        rgSeq: 0,
        btnNm: "",
        param: null,
      },
    });
  },
}));

export default useListRowInfStroe;

// {
//   name: "detailInf-storage",
//   partialize: (state) => ({
//     detailParams: state.listRowInf,
//   }),
// }
